import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { CustomEvent } from './custom-event';
import { GtmCustomEventNameEnum } from './gtm-custom-event-name.enum';

@Injectable()
export class GtmCustomEventService {
  private readonly customEventsSubject = new BehaviorSubject<CustomEvent | undefined>(undefined);
  readonly customEvent$ = this.customEventsSubject.asObservable();

  trackEvent(eventName: GtmCustomEventNameEnum, parameters?: Record<string, string>): void {
    this.customEventsSubject.next(this.getFormatedCustomEvent(eventName, parameters));
  }

  private getFormatedCustomEvent(eventName: GtmCustomEventNameEnum, parameters?: Record<string, string>): CustomEvent {
    let customEvent: CustomEvent = this.createCustomEvent(eventName);

    if (!this.isParametersRecordEmptyOrNull(parameters)) {
      customEvent = this.getCustomEventWithParameters(customEvent, parameters!);
    }

    return customEvent;
  }

  private isParametersRecordEmptyOrNull(parameters?: Record<string, string>): boolean {
    return !parameters || Object.keys(parameters).length === 0;
  }

  private getCustomEventWithParameters(customEvent: CustomEvent, parameters: Record<string, string>): CustomEvent {
    return { ...customEvent, ...parameters };
  }

  private createCustomEvent(eventName: GtmCustomEventNameEnum): CustomEvent {
    return { event: eventName };
  }
}
